import Swiper from 'swiper';
import { Navigation, FreeMode, Thumbs, A11y } from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};
let swiperDomainThumbs;
let swiperDomain;

const domCache = () => {
    $DOM.container = $(".domain-slider");
    if (!$DOM.container.length) {
        return;
    }
    $DOM.swiperDomain = $DOM.container.find("#js-domain-slider");
    $DOM.swiperDomainThumbs = $DOM.container.find('#js-domain-slider-thumbs');
}

const initSwiper = () => {
    swiperDomainThumbs = new Swiper($DOM.swiperDomainThumbs[0], {
        modules: [Navigation, FreeMode, A11y],
        init: false,
        slidesPerView: 'auto',
        spaceBetween: 4,
        // centerInsufficientSlides: true,
        // preventClicksPropagation: false,
        roundLengths: true,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        // slideToClickedSlide: true,
        freeMode: true,
        watchOverflow: true,
        watchSlidesProgress: true,
        a11y: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        breakpoints: {
            768: {
                slidesOffsetBefore: 72,
                slidesOffsetAfter: 72,
            }
        }
    });
    swiperDomain = new Swiper($DOM.swiperDomain[0], {
        modules: [A11y, Thumbs],
        init: false,
        slidesPerView: 1,
        spaceBetween: 32,
        preventInteractionOnTransition: false,
        speed: 750,
        preventClicksPropagation: false,
        roundLengths: true,
        centeredSlides: true,
        autoHeight: true,
        // loop: true,
        // loopedSlides: $("#js-domain-slider .swiper-slide").length,
        a11y: true,
        navigation: false,
        watchOverflow: true,
        thumbs: {
            swiper: swiperDomainThumbs,
        },
        breakpoints: {
            1024: {
                allowTouchMove: false, // preventing the touch slide - only navigate with pagination swiper
            }
        }
    });

    swiperDomainThumbs.on("init", onInitThumbs);
    swiperDomainThumbs.init();

    swiperDomain.on("init", onInitMain);
    swiperDomain.init();
}

const onInitThumbs = () => {
    $DOM.swiperDomainThumbs.addClass("is-init");
}

const onInitMain = () => {
    $DOM.swiperDomain.addClass("is-init");
}


const domainSlider = {
    init: () => {
        domCache();
        if (!$DOM.container.length) {
            return;
        }
        initSwiper();

    }
};

export default domainSlider;